import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'column',
    marginTop: 20,
    marginBottom: 10,
    // borderWidth: 1,
    // borderColor: "#000",
    padding: 8,
    // backgroundColor: '#F9F9F9',
  },
  reportTitle: {
    fontSize: 9,
    lineHeight: 1.6,
    color: '#000',
  },
});

const InvoiceEmergency = () => (
  <View style={styles.titleContainer}>
    <Text style={{fontSize:10, marginBottom:8}}>Important Notes:</Text>
    <Text style={styles.reportTitle}>
       
      • The hotel owner or experience provider may request a copy of your passport upon check-in. {'\n'}
      • To avoid unnecessary charges, please ensure that you are familiar with the service provider’s cancellation policy. {'\n'}
      • We strive to provide you with a quality service. If you feel you are not receiving the service you deserve, please contact our emergency number provided.
    </Text>
  </View>
);

export default InvoiceEmergency;
